import React from 'react';
import { useAppSelector } from '../store/hooks';
import VisibleSummaries from './VisibleSummaries';
import SummaryManager from './SummaryManager';

const SummariesPage: React.FC = () => {
  const { user } = useAppSelector((state) => state.auth);

  // Show SummaryManager for admins (admin, anis-admin, superadmin), VisibleSummaries for regular users
  const adminRoles = ['admin', 'anis-admin', 'superadmin'];
  if (user?.role && adminRoles.includes(user.role)) {
    return <SummaryManager />;
  }

  return <VisibleSummaries />;
};

export default SummariesPage;